import { sectionLabels } from "../section-labels";
/**
 * Product policies — OPTIONAL (not locked). The store-policy accordion on the
 * PDP. Split out of the legacy `product-details` section. Removable + addable:
 * a store with no policies removes it, and adds it back from the Add-section
 * flow when it wants policies. Not `criticalForSeo` (peripheral content). Lives
 * under `templates.product` only.
 */
export const productPoliciesSchema = {
    type: "product-policies",
    name: sectionLabels["product-policies"],
    description: {
        ar: "روابط سياسات المتجر أسفل صفحة المنتج.",
        en: "The store-policy links shown on the product page.",
    },
    locked: false,
    maxPerTemplate: 1,
    availableOnTemplates: ["product"],
    settings: [
        {
            id: "showPolicies",
            type: "checkbox",
            label: { ar: "إظهار روابط سياسات المتجر", en: "Show store policies" },
            default: true,
        },
    ],
};
//# sourceMappingURL=product-policies.js.map